import { useNotifications } from '@/app/providers/notifications';

export function NotificationCenter() {
  const { notifications, dismissNotification } = useNotifications();

  if (notifications.length === 0) {
    return null;
  }

  return (
    <div className="notification-center">
      {notifications.map((notification) => (
        <div className="notification" key={notification.id}>
          <span>{notification.message}</span>
          {notification.actionLabel && notification.onAction ? (
            <button
              type="button"
              onClick={() => {
                notification.onAction?.();
                dismissNotification(notification.id);
              }}
            >
              {notification.actionLabel}
            </button>
          ) : (
            <button type="button" onClick={() => dismissNotification(notification.id)}>
              Close
            </button>
          )}
        </div>
      ))}
    </div>
  );
}